import React,{useEffect,useState} from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useParams } from "react-router-dom";
import api from "../../Api";

const ImageSlider = () => {

  const [destinations,setDestinations] = useState([])
let {id} = useParams();

  useEffect(()=>{
    const getImages = async()=>{
      const response = await api.get(`/destinations/${id}`)
  
      setDestinations(response?.data?.data?.photos);
    }
    getImages();
  },[])

  

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  return (
    <div style={{ width: "80%", margin: "auto",paddingTop:"30px",height:"90vh"}}>
      <h3 style={{textAlign:"center",textDecoration:"Underline",color:"brown"}}>These are the Propular Destination Images</h3>
      <Slider {...settings}>
        {destinations.map((src, index) => (
          <div key={index}>
            <img
              src={src}
              alt={`slide-${index}`}
              style={{
                width: "100%",
                height: "350px",
                objectFit: "cover",
                borderRadius: "10px",
              }}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;
